import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AlertTriangle, FileWarning, Clock, ChevronRight } from 'lucide-react';
import { Badge } from '../ui/badge';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Card = ({ icon: Icon, label, count, items, color, testid, hrefBuilder }) => (
  <div data-testid={testid} className={`bg-[#141414] border ${count > 0 ? 'border-' + color : 'border-[#262626]'} rounded-md p-4 hover:border-[#D4AF37]/40 transition`}>
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <Icon className={`w-5 h-5 ${count > 0 ? `text-${color.replace('/30', '-300')}` : 'text-[#A3A3A3]'}`} />
        <p className="text-white text-sm font-medium">{label}</p>
      </div>
      <Badge className={count > 0 ? `bg-${color.replace('/30','/15')} text-${color.replace('/30','-300')} border border-${color}` : 'bg-[#262626] text-[#A3A3A3] border-[#404040]'}>{count}</Badge>
    </div>
    {items?.length > 0 ? (
      <ul className="divide-y divide-[#262626]">
        {items.slice(0, 4).map((it) => (
          <li key={it.id}>
            <Link to={hrefBuilder(it)} className="flex items-center justify-between py-2 hover:text-[#D4AF37]" data-testid={`alert-item-${it.id}`}>
              <div className="min-w-0">
                <p className="text-white text-sm truncate">{it.work_order_number} · <span className="text-[#A3A3A3]">{it.property_name}</span></p>
                <p className="text-[#525252] text-xs truncate">{it.issue}{it.estimated_amount ? ` · $${Number(it.estimated_amount).toLocaleString()}` : ''}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-[#525252] shrink-0" />
            </Link>
          </li>
        ))}
        {items.length > 4 && <li className="pt-2 text-[#525252] text-xs">+{items.length - 4} more</li>}
      </ul>
    ) : (
      <p className="text-[#525252] text-xs italic">All clear.</p>
    )}
  </div>
);

const PmDashboardAlerts = () => {
  const [alerts, setAlerts] = useState({ pending_pm_approvals: 0, missing_pos: 0, awaiting_authorization: 0, pending_pm_approvals_items: [], missing_pos_items: [], awaiting_authorization_items: [] });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/pm/dashboard/alerts`, { withCredentials: true });
        if (alive) setAlerts(data);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div data-testid="pm-dashboard-alerts" className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <Card icon={AlertTriangle} label="Pending PM Approvals" count={alerts.pending_pm_approvals} items={alerts.pending_pm_approvals_items} color="yellow-500/30" testid="card-pending-pm" hrefBuilder={(it) => `/pm/work-orders/${it.id}`} />
      <Card icon={FileWarning}   label="Missing POs"          count={alerts.missing_pos}          items={alerts.missing_pos_items}          color="red-500/30"    testid="card-missing-pos" hrefBuilder={(it) => `/pm/work-orders/${it.id}`} />
      <Card icon={Clock}         label="Awaiting Authorization" count={alerts.awaiting_authorization} items={alerts.awaiting_authorization_items} color="blue-500/30" testid="card-awaiting-auth" hrefBuilder={(it) => `/pm/work-orders/${it.id}`} />
    </div>
  );
};

export default PmDashboardAlerts;
